import { filter, get, includes } from 'lodash/fp';

/**
 * Gets the products ids of the products which should be unavailable in the product comparer.
 *
 * @param {object} param - An object.
 * @param {number} param.customerExcess - The excess value on the customer object.
 * @param {Array.string>} param.parentProductIds - Each of the comparer products parent ids.
 * @param {object} param.productIdsWithExcess - Contains keys of each parent id. Each value is the applicable excess.
 */
// @ts-expect-error - Automatic, Please fix when editing this file
const getUnavailableProducts = ({ customerExcess, parentProductIds, productIdsWithExcess }) =>
  filter((parentId) => {
    const excessValues = get(parentId, productIdsWithExcess);
    return !includes(customerExcess, excessValues);
  }, parentProductIds);

export default getUnavailableProducts;
